import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Footer } from './Footer';
interface PortalShellProps {
  children: React.ReactNode;
}
export function PortalShell({
  children
}: PortalShellProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="min-h-screen bg-background" data-id="element-90">
      <Sidebar isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} data-id="element-91" />
      <div className="lg:pl-72 flex flex-col min-h-screen" data-id="element-92">
        <TopBar onOpenMenu={() => setIsMobileMenuOpen(true)} data-id="element-93" />
        <main className="flex-1 py-6 px-4 sm:py-10 sm:px-6 lg:px-8" data-id="element-94">
          {children}
        </main>
        <Footer data-id="element-95" />
      </div>
    </div>;
}